import React, { useState, useEffect, useCallback } from "react";
import ModalB from "react-bootstrap/Modal";
import "./modal.css";
import api from "../../services/axios";
import Loading from "../../assets/home/loading.gif";
import {
  FaUser,
  FaBuilding,
  FaStar,
  FaThumbsUp,
  FaCheck,
  FaTimes,
  FaClock,
} from "react-icons/fa";

function normalizarStatus(status) {
  const valor = String(status || "")
    .trim()
    .toLowerCase();
  if (valor === "confirmado") return "confirmado";
  if (valor === "recusado") return "recusado";
  return "pendente";
}

function labelStatus(status) {
  if (status === "confirmado") return "Confirmado";
  if (status === "recusado") return "Recusado";
  return "Pendente";
}

const ModalEscolhasPatrocinador = ({ show, toggleModal, titulo, userId }) => {
  const [escolhas, setEscolhas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const carregarEscolhas = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError("");
    try {
      const response = await api.get(`/usuarios-get/${userId}`);
      if (response.status === 200) {
        const usuario = response.data.user;
        const lista =
          usuario?.infoPatrocinador?.escolhaPatrocinador ||
          usuario?.info_patrocinador?.escolha_patrocinador ||
          [];
        setEscolhas(Array.isArray(lista) ? lista : []);
      }
    } catch (err) {
      console.error("Erro ao carregar escolhas:", err);
      setError("Erro ao carregar as escolhas do patrocinador");
      setEscolhas([]);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (show && userId) {
      carregarEscolhas();
    }
  }, [show, userId, carregarEscolhas]);

  const handleModal = () => {
    setEscolhas([]);
    setError("");
    toggleModal();
  };

  const escolhasPrioritarias = escolhas.filter(
    (escolha) => escolha.tipo === "mais_quero"
  );
  const escolhasDesejaveis = escolhas.filter(
    (escolha) => escolha.tipo === "quero"
  );

  const renderLista = (lista, tituloLista, icone, corTema) => {
    const comStatus = lista.map((escolha) => ({
      ...escolha,
      statusNormalizado: normalizarStatus(escolha.status),
    }));

    const confirmados = comStatus.filter(
      (e) => e.statusNormalizado === "confirmado"
    ).length;
    const recusados = comStatus.filter(
      (e) => e.statusNormalizado === "recusado"
    ).length;
    const pendentes = comStatus.filter(
      (e) => e.statusNormalizado === "pendente"
    ).length;
    const total = comStatus.length;

    // Ordem do protocolo: sequência; status só como informação visual
    const listaOrdenada = [...comStatus].sort(
      (a, b) => Number(a.sequencia || 0) - Number(b.sequencia || 0)
    );

    return (
      <div className="lista-escolhas">
        <div className="header-lista-escolhas" style={{ backgroundColor: corTema }}>
          <div className="titulo-lista">
            {icone}
            <h6>{tituloLista}</h6>
            <span className="contador" title="Confirmados / total">
              (
              <span className="confirmados">{confirmados}</span>
              <span className="separador">/</span>
              <span className="total">{total}</span>)
            </span>
          </div>
          {total > 0 ? (
            <div className="resumo-status-lista">
              <span className="resumo-status-lista__item resumo-status-lista__item--confirmado">
                {confirmados} conf.
              </span>
              <span className="resumo-status-lista__item resumo-status-lista__item--recusado">
                {recusados} rec.
              </span>
              <span className="resumo-status-lista__item resumo-status-lista__item--pendente">
                {pendentes} pend.
              </span>
            </div>
          ) : null}
        </div>
        <div className="body-lista-escolhas">
          {listaOrdenada.length > 0 ? (
            listaOrdenada.map((escolha) => {
              const status = escolha.statusNormalizado;
              return (
                <div
                  key={escolha.id || `${escolha.tipo}-${escolha.sequencia}-${escolha.user_id || escolha.idUsuario}`}
                  className={`item-escolha item-escolha--${status}`}
                >
                  <div className="info-usuario">
                    <div className="nome-usuario">
                      {escolha.sequencia ? (
                        <span className="seq-escolha">{escolha.sequencia}º</span>
                      ) : (
                        <FaUser className="icone-usuario" />
                      )}
                      {escolha.usuario?.nome || "Nome não informado"}
                    </div>
                    <div className="empresa-usuario">
                      <FaBuilding className="icone-empresa" />
                      {escolha.usuario?.empresa || "Empresa não informada"}
                    </div>
                  </div>
                  <div
                    className={`status-escolha status-escolha--${status}`}
                    title={`Status: ${labelStatus(status)}`}
                  >
                    {status === "confirmado" ? (
                      <FaCheck aria-hidden />
                    ) : status === "recusado" ? (
                      <FaTimes aria-hidden />
                    ) : (
                      <FaClock aria-hidden />
                    )}
                    <span>{labelStatus(status)}</span>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="lista-vazia">
              <p>Nenhuma escolha {tituloLista.toLowerCase()}</p>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <ModalB show={show} onHide={handleModal} size="lg">
      <ModalB.Header closeButton>
        <ModalB.Title className="titulo-modal">
          {titulo || "Escolhas do Patrocinador"}
        </ModalB.Title>
      </ModalB.Header>
      <ModalB.Body>
        {loading ? (
          <div className="area-loading-blur">
            <div className="area-loading">
              <img src={Loading} alt="Carregando..." />
            </div>
          </div>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : (
          <div className="container-escolhas">
            <div className="row">
              <div className="col-md-6">
                {renderLista(
                  escolhasPrioritarias,
                  "Prioritário",
                  <FaStar className="icone-lista" />,
                  "#6c757d"
                )}
              </div>
              <div className="col-md-6">
                {renderLista(
                  escolhasDesejaveis,
                  "Desejável",
                  <FaThumbsUp className="icone-lista" />,
                  "#17a2b8"
                )}
              </div>
            </div>
            {escolhas.length === 0 && !loading && (
              <div className="sem-escolhas">
                <div className="alert alert-info text-center">
                  <h5>Nenhuma escolha encontrada</h5>
                  <p>Este patrocinador ainda não fez nenhuma escolha.</p>
                </div>
              </div>
            )}
          </div>
        )}
      </ModalB.Body>
    </ModalB>
  );
};

export default ModalEscolhasPatrocinador;
